module.exports = __webpack_public_path__ + "static/media/message-divider.19cbb72a.png";